<span class="text-nowrap contenedor-estado-boolean-label"
    [ngStyle]="{'color': (valor) ? _configuracion?.colorTrue : _configuracion?.colorFalse}">
    <neo-icono *ngIf="_configuracion.modoVisual == 'icono' || _configuracion.modoVisual == 'ambos'"
        [icono]="(valor) ? _configuracion?.iconoTrue : _configuracion.iconoFalse"
        [iconoClase]="(valor) ? _configuracion?.iconoClaseTrue + ' mr-5 ' : _configuracion.iconoClaseFalse + ' mr-5 '"></neo-icono>
    <span *ngIf="_configuracion.modoVisual == 'si-no' || _configuracion.modoVisual == 'ambos'">
        {{ (valor) ? 'Si' : 'No' }}
    </span>
</span>